module.exports = __webpack_public_path__ + "img/icon-swiper-right.5405c7cf.png";